var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60074 2.81958C0 5.1393 0 8.87316 0 16.34V17.66C0 25.1269 0 28.8608 2.60074 31.1804C5.20164 33.5 9.38809 33.5 17.76 33.5H19.24C27.612 33.5 31.7984 33.5 34.3992 31.1804C37 28.8608 37 25.1269 37 17.66V16.34C37 8.87309 37 5.13923 34.3992 2.81958C31.7984 0.5 27.612 0.5 19.24 0.5H17.76C9.38801 0.5 5.20156 0.5 2.60074 2.81958ZM6.24375 10.5376H10.4679C10.6067 16.8351 13.7208 19.5026 16.1875 20.0526V10.5375H20.165V15.9688C22.6008 15.735 25.16 13.26 26.0233 10.5375H30.0008C29.6754 11.9495 29.0269 13.2863 28.0958 14.4646C27.1647 15.6428 25.9711 16.637 24.5896 17.385C26.1321 18.068 27.4945 19.0352 28.5868 20.2228C29.6791 21.4103 30.4763 22.791 30.9258 24.2738H26.5475C26.1441 22.9858 25.3231 21.8329 24.1876 20.9596C23.0521 20.0863 21.6527 19.5315 20.165 19.365V24.2738H19.6871C11.2542 24.2738 6.44419 19.1175 6.24375 10.5375V10.5376Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/vk_icon.c209c8edaabfc4b2f7fa39b4949908e3.svg";
export { ForwardRef as ReactComponent };